<mat-dialog-content class="copy-dialog">
   <div class="message">{{message}}</div>
   <div *ngIf="this.column != 'hawb'" class="message-button">
      <button mat-stroked-button color="primary" (click)="copy()">
         <mat-icon>content_copy</mat-icon>
         Copy To Clipboard And Close
      </button>
   </div>
   <div *ngIf="this.column == 'hawb'" class="message-button">
      <button mat-stroked-button color="primary" (click)="copy()">
         <mat-icon>content_copy</mat-icon>
         Copy To Clipboard
      </button>
      <button class="open-new-window" mat-stroked-button color="primary" (click)="openWindow()">
         <mat-icon>open_in_new</mat-icon>
         Open In New Window
      </button>
   </div>
</mat-dialog-content>